"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._CSVOutput = {
    type: "structure",
    required: [],
    members: {
        QuoteFields: {
            shape: {
                type: "string"
            }
        },
        QuoteEscapeCharacter: {
            shape: {
                type: "string"
            }
        },
        RecordDelimiter: {
            shape: {
                type: "string"
            }
        },
        FieldDelimiter: {
            shape: {
                type: "string"
            }
        },
        QuoteCharacter: {
            shape: {
                type: "string"
            }
        }
    }
};
//# sourceMappingURL=_CSVOutput.js.map